module.exports = __webpack_public_path__ + "nc_static/media/file_pdf.e2afeead.svg";